import classnames from "classnames";
import TableContainer from "components/Common/TableContainer";
import { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { Input, Nav, NavItem, NavLink } from "reactstrap";
interface Props {
  open: boolean;
  data: any;
  onClose: () => void;
  onSubmit: (value: any) => void;
}

const ConfigServiceModule = ({
  setFieldValue,
  featureSettings,
  mode,
  onClose,
  handleSubmit,
}: any) => {
  const { t } = useTranslation();
  const [tabModal, setTabModal] = useState("1");
  const [updatedFeatureSettings, setUpdatedFeatureSettings] = useState([]);
  const [mediaGroup, setMediaGroup] = useState([]);
  const [serviceGroup, setServiceGroup] = useState([]);

  const [data, setData] = useState<any>([]);

  useEffect(() => {
    if (tabModal === "1") {
      setData(serviceGroup);
    } else {
      setData(mediaGroup);
    }
  }, [tabModal]);

  const updateParent = (id: any, value: any) => {
    setUpdatedFeatureSettings((prev: any) =>
      prev.map((item: any) => {
        if (item.id === id) {
          return { ...item, is_enabled: value };
        }
        return item;
      })
    );
  };

  const updateChild = (parentId: any, childId: any, value: any) => {
    setUpdatedFeatureSettings((prev: any) =>
      prev.map((item: any) => {
        if (item.id === parentId) {
          return {
            ...item,
            childrens: item?.childrens?.map((child: any) => {
              if (child.id === childId) {
                return { ...child, is_enabled: value };
              }
              return child;
            }),
          };
        }
        return item;
      })
    );
  };

  const columns = useMemo(
    () => [
      {
        Header: t("media.main_menu"),
        accessor: "name",
        thClass: "text-center none-empty",

        Cell: (cell: any) => {
          const rows = cell?.row?.original;
          return (
            <div className=" h-100 pt-2 d-flex mb-auto align-items-start justify-content-between text-center">
              {cell?.value}
              <div className="form-check form-switch form-switch-md">
                <Input
                  name="is_active"
                  className="form-check-input"
                  type="checkbox"
                  role="switch"
                  id="directMessage"
                  checked={rows?.is_enabled}
                  onChange={(event: any) =>
                    updateParent(rows?.id, event.target.checked)
                  }
                />
              </div>
            </div>
          );
        },
      },
      {
        Header: t("  "),
        accessor: "",
        thClass: "",
        Cell: (cell: any) => <div className="w-0 text-center"></div>,
      },
      {
        Header: t("media.sub_menu"),
        accessor: "childrens",
        thClass: "text-center none-empty",
        Cell: (cell: any) => {
          return (
            <div className="w-100 text-center d-flex flex-column gap-2">
              {cell?.value?.map((item: any, index: number) => (
                <div
                  key={index}
                  style={{ height: "36px" }}
                  className="d-flex align-items-center justify-content-between text-center"
                >
                  <p className="m-0">{item?.name}</p>
                  <div className="form-check form-switch form-switch-md">
                    <Input
                      name="is_active"
                      className="form-check-input"
                      type="checkbox"
                      role="switch"
                      id="directMessage"
                      checked={item?.is_enabled}
                      onChange={(event: any) =>
                        updateChild(
                          cell?.row?.original?.id,
                          item?.id,
                          event.target.checked
                        )
                      }
                    />
                  </div>
                </div>
              ))}
            </div>
          );
        },
      },
    ],
    []
  );

  const onSubmit = (e: any) => {
    e.preventDefault();
    setFieldValue("feature_settings", updatedFeatureSettings);
    handleSubmit();
  };

  useEffect(() => {
    if (tabModal === "1") {
      setData(serviceGroup);
    } else {
      setData(mediaGroup);
    }
  }, [tabModal, serviceGroup, mediaGroup]);

  useEffect(() => {
    setUpdatedFeatureSettings(featureSettings);
    const serviceGroup = featureSettings.filter(
      (item: any) => item.group === "service"
    );
    setData(serviceGroup);
  }, [featureSettings]);

  useEffect(() => {
    const mediaGroup = updatedFeatureSettings.filter(
      (item: any) => item.group === "media"
    );
    setMediaGroup(mediaGroup);
    const serviceGroup = updatedFeatureSettings.filter(
      (item: any) => item.group === "service"
    );
    setServiceGroup(serviceGroup);
  }, [updatedFeatureSettings]);

  useEffect(() => {
    return () => {
      setUpdatedFeatureSettings([]);
    };
  }, []);

  return (
    <div>
      <Nav
        className="nav-tabs-custom config-tabs w-100 d-flex rounded card-header-tabs border-bottom-0 mt-0"
        role="tablist"
      >
        <NavItem>
          <NavLink
            className={`cursor-pointer ${classnames({
              active: tabModal === "1",
            })}`}
            onClick={() => {
              setTabModal("1");
            }}
          >
            {t("media.PressconService")}
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            className={`cursor-pointer ${classnames({
              active: tabModal === "2",
            })}`}
            onClick={() => {
              setTabModal("2");
            }}
          >
            {t("media.MediaHomepage")}
          </NavLink>
        </NavItem>
      </Nav>

      <form onSubmit={onSubmit} className="w-100">
        <div className="fw-bold fs-14 text-gray-600 mt-4">
          {t("media.features_option")}
        </div>
        <div className="flex-fill mt-4 ">
          <TableContainer
            divClass="table-responsive table-card m-0 h-100"
            tableClass="config-table custom-table-level align-middle w-100 !border-0"
            theadClass=""
            columns={columns}
            data={data}
            // isLoading={loading}
            isShowPagination={false}
            scrollbarOs={false}
            // customPageSize={pagination?.page_size}
            // customPageIndex={pagination?.page - 1}
            // totalRecords={pagination?.total}
            // customPageCount={Math.ceil(
            //   pagination?.total / pagination?.page_size
            // )}
            // handleChangePage={handleChangePage}
          />
        </div>
        <div className="hstack gap-2 mt-5 justify-content-center">
          {mode === "view" ? (
            <button
              type="button"
              onClick={() => {
                onClose();
              }}
              className="btn btn-primary mx-auto fs-14 w-25"
            >
              {t("media.Check")}
            </button>
          ) : (
            <>
              <button
                className="btn btn-soft-secondary fs-14 w-25"
                type="button"
                color="light"
                onClick={() => onClose()}
              >
                {t("media.Cancel")}
              </button>
              <button type="submit" className="btn btn-primary fs-14 w-25">
                {t("media.Save")}
              </button>
            </>
          )}
        </div>
      </form>
    </div>
  );
};

export default ConfigServiceModule;
